/* HM 26/09/2026 - Audit du 25/09 : la barre d'achat mobile (.fbar) doublait le bouton du haut de page dès l'arrivée.
   Elle n'apparaît plus qu'une fois ce bouton sorti de l'écran, comme une barre de rappel. */
(function(){
  if (!('IntersectionObserver' in window)) return;
  function init(){
    if (!document.querySelector('.fbar')) return;
    var cta = document.querySelector('.in2-hero .in2-btn, .in2-hero a.in2-btn');
    if (!cta) return;
    var root = document.documentElement;
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) root.classList.add('hm-fbar-attente');
        else root.classList.remove('hm-fbar-attente');
      });
    }, { threshold: 0 }).observe(cta);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
